export enum MFNames {
	reki = 'reki',
	efr = 'efr',
	efrFast = 'efrFast',
	efrCommon = 'efrCommon',
	apiReki = 'apiReki',
	apiEfr = 'apiEfr',
	common = 'common',
	designTokens = 'designTokens',
	staticFiles = 'staticFiles',
	uiKit = 'uiKit',
}

export type MFNamesKeys = keyof typeof MFNames;
